import React from 'react';
import { Amplify } from 'aws-amplify';
import { awsConfig } from './config/aws.config';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  AuthUserProvider,
  PMSIntegrationUserProvider,
} from './contexts/AuthUserContext';
import { axiosSetup } from './fetchAPI/axios.setup';
import { createRoot } from 'react-dom/client';

import * as Sentry from '@sentry/react';
import PmsIntegration from './PmsIntegration';
import { ComponentsRoot } from './ComponentsRoot';
import { initComponents } from './initComponents';
import { EmbeddedRoot } from './embedded/EmbeddedRoot';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    environment:
      process.env.REACT_APP_SENTRY_ENVIRONMENT || 'unknown_environment',
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new Sentry.BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}

console.log('awsConfig:', awsConfig);

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: awsConfig.USER_POOL_ID!,
      userPoolClientId: awsConfig.USER_POOL_CLIENT_ID!,
      identityPoolId: awsConfig.IDENTITY_POOL_ID!,
      loginWith: {
        oauth: {
          domain: awsConfig.IDP_DOMAIN!,
          scopes: [
            'email',
            'profile',
            'openid',
            'aws.cognito.signin.user.admin',
            'gekkovet/read',
            'gekkovet/write',
            'gekkovet/user.write',
            'gekkovet/user.read',
          ],
          redirectSignIn: [awsConfig.REDIRECT_SIGN_IN!],
          redirectSignOut: [awsConfig.REDIRECT_SIGN_OUT!],
          responseType: 'code',
        },
      },
    },
  },
});

if (process.env.REACT_APP_ENTRYPOINT === 'components') {
  console.log('index.tsx: Running in components mode');
  initComponents();
  console.log('index.tsx: Initializing components app');
  axiosSetup();
  const container = document.getElementById('root');
  const root = createRoot(container!);
  root.render(<ComponentsRoot />);
} else {
  axiosSetup();

  const container = document.getElementById('root');
  const root = createRoot(container!);
  if (/^\/pms/.test(window.location.pathname)) {
    root.render(
      <PMSIntegrationUserProvider>
        <PmsIntegration />
      </PMSIntegrationUserProvider>
    );
  } else if (/^\/embedded/.test(window.location.pathname)) {
    // Embedded mode for native app webview integration
    // Does not use Amplify auth - tokens are provided via postMessage from native app
    root.render(<EmbeddedRoot />);
  } else {
    root.render(
      // Unfortunately Material-ui doesn't support strict mode. The promise is it will work in release v5
      // <React.StrictMode>
      <AuthUserProvider>
        <App />
      </AuthUserProvider>
      // </React.StrictMode>,
    );
  }

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals.console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}
